import { useWinners } from '@/shared/hooks'
import { StatsBlock, ReviewsBlock, RadarBlock, ChartBlock, WinnersTable } from './components'

export function HomePage() {
  const { data: winners = [] } = useWinners()

  return (
    <div className="space-y-2 animate-fade-in">
      {/* 2×2 grid: Stats / Reviews / Radar / Chart */}
      <div className="grid grid-cols-1 lg:grid-cols-2 lg:grid-rows-2 gap-2 auto-rows-auto lg:h-[68vh]">
        <StatsBlock />
        <ReviewsBlock winners={winners} />
        <RadarBlock />
        <ChartBlock />
      </div>

      {/* Winners table */}
      <WinnersTable winners={winners} />
    </div>
  )
}
